import { combineReducers } from "redux";
import { authReducer } from "../pages/auth/store/auth.reducer";
import { nftReducer } from "../pages/nfts/store/nfts.reducer";
import { adminReducer } from "../pages/admin/store/admin.reducer";
import { adminEdmReducer } from "../pages/admin/edm/store/admin-edm.reducer";
import artworksReducer from "./artworks/artworks.slice";
import galleriesReducer from './galleries/galleries.slice';
import gallerySetupReducer from './gallerysetup/gallerysetup.slice';

const rootReducer = combineReducers({
    auth: authReducer,
    nft: nftReducer,
    admin: adminReducer,
    adminEdm: adminEdmReducer,
    artworks: artworksReducer,
    galleries: galleriesReducer,
    gallerySetup: gallerySetupReducer
});

export type AppState = ReturnType<typeof rootReducer>;
export default rootReducer;
